<template>
    <o-modal @showModal="showModal">
        <template v-slot:header>
            {{ modalTitle }}
        </template>
        <template v-slot:body>
            <o-form autocomplete="off">
                <div v-if="errors.length">
                    <div class="alert alert-danger">
                        <p>
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                            </ul>
                        </p>
                    </div>
                </div>
                <o-form-group title="Upload File" name="uploadFile" class="text-start mb-2">
                    <span class="text-danger">*</span>
                    <o-import-file v-model="file" @selectFile="fileSelected"/>
                </o-form-group>
                
                <div class="d-flex d-inline-block">
                    <div class="me-2">
                        <o-button @click="importFile" :variant="'primary'" type="button">Import</o-button>
                    </div>
                    <div class="ms-1">
                        <o-button @click="closeModal" :variant="'outline-secondary'">Close</o-button>
                    </div>
                </div>
            </o-form>
        </template>
    </o-modal>
</template>

<script>
import { OModal, OForm, OFormGroup, OButton, OImportFile } from '@/components/OmnihControl';
import { mapActions } from 'vuex';

export default {
    name: 'ImportMerchant',
    components: {
        OImportFile,
        OModal,
        OForm,
        OFormGroup,
        OButton,
    },
    data() {
        return {
            file: null, 
            errors: [],
            modalTitle: 'Import Merchants', 
        };
    },
    methods: {
        ...mapActions('merchant', ['import']),

        closeModal() {
            this.$emit('closeModal');
        },
        fileSelected(file) {
            this.file = file;
        },
        importFile() {
            this.errors = [];

            if (!this.file) {
                this.errors.push('File is required.');
                return;
            }

            const formData = new FormData();
            formData.append('file', this.file);
            this.$emit('saveDetail', formData);
            this.closeModal();
        }
    },
}
</script>

<style>
    .spinner{
        position: fixed;
        z-index: 3;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.5);
        height: 100%;
        width: 100%;
    }
    .spinner-position{
        display: block;
        position: fixed;
        z-index: 1031;
        top: 50%;
        right: 50%;
        margin-top: 5px; 
        margin-left: 80px; 
    }
</style>
